import { Directive, ElementRef, effect, inject, input } from '@angular/core';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

function toClassValues(value: ClassValue | ClassValue[]): ClassValue[] {
  return Array.isArray(value) ? value : [value];
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[xclass]',
})
export class XClass {
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  /** User-provided class for merging. */
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  /** Directive input allows class values accepted by `clsx` */
  readonly xclass = input<ClassValue | ClassValue[]>();

  constructor() {
    effect(() => {
      const userClass = this.userClass();
      const xclass = this.xclass();

      const el = this.elementRef.nativeElement;
      if (!el?.classList) return;

      const merged = twMerge(clsx(...toClassValues(xclass ?? []), userClass));
      el.className = merged;
    });
  }
}
